module.exports = __webpack_public_path__ + "static/esco-3-199b729e30b2852de4179fc858bd73c9.png";